import Heading from 'common/components/Heading';
import React from 'react';

interface Props {
    title: string;
    subTitle: string;
}

const Title = ({ title, subTitle }: Props) => (
    <>
        <Heading size="h5" variations={['heading--soft', 'heading--quarter-margin']}>
            {title}
        </Heading>
        <Heading size="h4" variations={['heading--no-margin']}>
            {subTitle}
        </Heading>
    </>
);

export default Title;
